import React from 'react';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { Schedule } from '../elements-forms/schedule';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

class RsvpAcceptModal extends React.Component {
  render () {
    const booking = _.get(this.props, 'booking.booking');
    const timezone = _.get(booking, 'start.timezone', {});
    const bookingSchedule = _.get(booking, 'schedule');
    const publicSchedule = _.get(booking, 'public_fields.guest_schedule');
    const schedule = publicSchedule || bookingSchedule;
    const flexibleDateTime = _.get(booking, 'flexibleDateTime');

    return (
      <BootstrapModal
        {...this.props}
        ref="rsvpAcceptModal"
        header={
          this.props.header || <i className="ico ico-2x icon-confirmed-check" style={{ color: '#46bc93' }} />
        }
        body={
          <div className="attendee-accept-modal-container">
            <h3 className="text-center">
              <FormattedMessage id="invite.rsvp_accept_modal.you_r_confirmed" defaultMessage="You're confirmed" />
            </h3>

            <h3 className="text-center text-brand-primary">
              <FormattedMessage id="invite.rsvp_accept_modal.event_details" defaultMessage="Event Details" />
            </h3>

            <Schedule
              timeZoneId={timezone ? timezone.id : 'America/Los_Angeles'}
              schedule={schedule}
              flexible={flexibleDateTime}
              customClass="text-center schedule-margin-bottom"
            />

            <div className="text-center">
              <button
                className="btn btn-primary classic"
                onClick={this.props.closeModal}
                style={{ width: '160px', marginBottom: '40px' }}
              >
                <FormattedMessage id="invite.rsvp_accept_modal.button_done" defaultMessage="Done" />
              </button>
            </div>
          </div>
        }
      />
    );
  }
}

function mapStateToProps (state) {
  const { booking } = state;

  return {
    booking
  };
}

export default connect(mapStateToProps)(RsvpAcceptModal);
